import React from 'react'
import {CTA} from 'common/styleguide/CTA'
import moment from 'moment'
import cx from 'classnames'
import {TextWithBolds} from 'common/TextWithBolds'
import styles from './Notification.scss'

export class Notification extends React.PureComponent {
  onCTAClicked = (notification, ctaType) => {
    if (!notification[ctaType]) {
      console.error(`no CTA of type ${ctaType} associated with notification id ${notification.id}`)
    }
    const {endpoint, payload, success_text: successText} = notification[ctaType]
    const {ctaClicked} = this.props

    ctaClicked(endpoint, payload, {id: notification.id, successText: successText, time: new Date(), error: null})
  }

  render () {
    const {n, actionTaken} = this.props

    return (
      <div className={cx(styles.Notification, n.readStatus === 'unseen' && styles.unseen)}>
        <div className={styles.imgContainer}>
          <a href={n.imageTarget.url}>
            <img src={n.image || '/images/profile_no_image.png'} alt='notification image' height='50' width='50' />
          </a>
        </div>
        <a href={n.textTarget.url} className={styles.textContainer}>
          {!actionTaken && <div><TextWithBolds text={n.richTitle} /></div>}
          {actionTaken && actionTaken.successText && <div><TextWithBolds text={actionTaken.successText} /></div>}
          {/* I'm not using the actionTaken.error text here because it's usually not human-readable */}
          {/* see: https://github.com/ridewithgps/ridewithgps/issues/4889#issuecomment-386367716 */}
          {actionTaken && actionTaken.error && <div className={styles.errorText}>Oops! We had a problem performing that action. Please refresh the page and try again.</div>}
          <div className={styles.time}>
            {actionTaken
              ? moment(actionTaken.time).fromNow()
              : moment(n.updatedAt).fromNow()}
          </div>
        </a>
        {!actionTaken && <div className={styles.ctaContainer}>
          {n.ctaSecondary && <CTA small link inline margins={false} onClick={() => this.onCTAClicked(n, 'ctaSecondary')}>
            {n.ctaSecondary.label}
          </CTA>}
          {n.ctaPrimary && <CTA small primary inline margins={false} onClick={() => this.onCTAClicked(n, 'ctaPrimary')}>
            {n.ctaPrimary.label}
          </CTA>}
        </div>}
      </div>
    )
  }
}
